import { useState } from 'react';
import ModalDialog from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { RequestMethod, pepApiRequest, useStatefulApi } from 'src/services';
import { generatePath, useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import { SiteClusters, SolutionSiteEdgeServiceItem } from '../../types';
import solutionsStore from '../../redux';
import { SolutionEdgeServiceFormFields } from '../formFields';
import { API_SOLUTION_SITES_CREATE_NANOMQ_SERVICE } from '../../constants';

type Props = {
  title: string;
  item: SolutionSiteEdgeServiceItem;
  open: boolean;
  onClose: () => void;
  siteId: string;
  siteName: string;
  edgeServiceUrl?: string;
};

function SolutionSiteServiceUrlCreateModal({
  siteId,
  siteName,
  edgeServiceUrl,
  item,
  title,
  open,
  onClose,
}: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const [url, setUrl] = useState('');
  const actions = useStoreUnitActions(solutionsStore);
  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_SOLUTION_SITES_CREATE_NANOMQ_SERVICE, {
          solutionId,
          siteId,
        }),
        params: { endpoint: params.nanoMQServiceUrl },
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: `${siteName} NanoMQ Service URL created`,
        text: 'Site NanoMQ Service URL has been successfully created.',
      });
      onClose();
      actions.details(solutionId);
    }
  );

  const handleChange = (event) => {
    setUrl(event.target.value);
  };

  const [form, handleSubmit] = useForm({
    values: item,
    fields: SolutionEdgeServiceFormFields(url, handleChange),
    onSubmit,
  });

  return (
    <ModalDialog
      data-testid="modal-dialog"
      open={open}
      title={`Add NanoMQ Service URL : ${siteName} `}
      titleStyle={{
        fontSize: '18px',
        fontFamily: 'Stolzl',
        fontWeight: 500,
      }}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Submit"
      maxWidth="sm"
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionSiteServiceUrlCreateModal;
